import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState } from '../reducers';
import type { AppDispatch } from '../store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;